import React, { useRef } from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from '../../Rebass';
import Button from '../../Button';
import Text from '../../Text';
import theme from '../../../theme';

interface FileInputProps {
  name?: string;
  label?: string;
  error?: string;
  color?: string;
  onChange?: (file: File) => void;
  bg?: string;
  value?: File;
  buttonLabel: string;
  disabled?: boolean;
}

const HiddenInput = styled.input`
  display: none;
`;

const InputContainer = styled(Flex)`
  border-radius: 4px;
  padding: 8px;
  ${({ error }) =>
    error ? `border: 1px solid ${theme.colors.statusError};` : ''}
`;

const FileInput = ({
  name,
  label,
  error,
  color,
  onChange,
  bg,
  value,
  buttonLabel,
  disabled,
}: FileInputProps) => {
  const hiddenFileInput = useRef(null);
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    onChange(fileUploaded);
  };

  return (
    <>
      {label && (
        <Box>
          <Text as="label" htmlFor={name} size="small" fontWeight="bold">
            {label}
          </Text>
        </Box>
      )}
      <InputContainer
        alignItems="center"
        bg={bg}
        mb={error ? [1] : [0]}
        error={error}
      >
        <Box mr={[2]}>
          <Button
            variant="outline"
            size="small"
            colorScheme={color}
            onClick={handleClick}
            type="button"
          >
            {buttonLabel}
          </Button>
        </Box>
        {value && <Text size="small">{value.name}</Text>}
      </InputContainer>
      {error && (
        <Text color="statusError" size="small">
          {error}
        </Text>
      )}
      <HiddenInput
        ref={hiddenFileInput}
        name={name}
        aria-label={label}
        onChange={handleChange}
        type="file"
        disabled={disabled}
      />
    </>
  );
};

export default FileInput;
